/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

// Global error handlers for new tab scenarios
window.addEventListener('error', (event: ErrorEvent) => {
  console.error('Global error caught:', event.error);
  
  const errorMessage = event.error?.message || event.message || 'Unknown error occurred';
  const errorStack = event.error?.stack || '';
  
  // Check for the specific USC library forEach error
  if (errorMessage.includes('Cannot read properties of undefined (reading \'forEach\')') ||
      errorMessage.includes('Cannot read properties of undefined (reading "forEach")') ||
      (errorMessage.includes('forEach') && errorStack.includes('schuco-vcl-usc-lib.mjs:10472')) ||
      errorMessage.includes('schuco-vcl-usc-lib.mjs:10472')) {
    
    // Store the error for the article viewer component to detect
    (window as any).__GLOBAL_USC_ERROR__ = {
      message: `USC Library Error: Cannot read properties of undefined (reading 'forEach'). This occurs when the article data structure is incompatible with the 3D viewer.`,
      originalError: event.error,
      timestamp: Date.now()
    };
    
    // Also store in the existing location for compatibility
    (window as any).__APP_RUNTIME_ERROR__ = event.error;
    
    console.error('USC Library forEach error detected and stored globally');
  } else {
    // Store other errors for general error detection
    (window as any).__APP_RUNTIME_ERROR__ = event.error;
  }
});

window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  console.error('Global promise rejection caught:', event.reason);
  
  const errorMessage = event.reason?.message || event.reason || 'Promise rejection occurred';
  const errorStack = event.reason?.stack || '';
  
  // Check for the specific USC library forEach error
  if (errorMessage.includes('Cannot read properties of undefined (reading \'forEach\')') ||
      errorMessage.includes('Cannot read properties of undefined (reading "forEach")') ||
      (errorMessage.includes('forEach') && errorStack.includes('schuco-vcl-usc-lib.mjs:10472')) ||
      errorMessage.includes('schuco-vcl-usc-lib.mjs:10472')) {
    
    // Store the error for the article viewer component to detect
    (window as any).__GLOBAL_USC_ERROR__ = {
      message: `USC Library Error: Cannot read properties of undefined (reading 'forEach'). This occurs when the article data structure is incompatible with the 3D viewer.`,
      originalError: event.reason,
      timestamp: Date.now()
    };
    
    // Also store in the existing location for compatibility
    (window as any).__APP_RUNTIME_ERROR__ = event.reason;
    
    console.error('USC Library forEach promise rejection detected and stored globally');
  } else {
    // Store other errors for general error detection
    (window as any).__APP_RUNTIME_ERROR__ = event.reason;
  }
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => {
    console.error('Bootstrap error:', err);
    
    // Check if it's the USC library error
    const errorMessage = err?.message || err || '';
    if (errorMessage.includes('Cannot read properties of undefined (reading \'forEach\')') ||
        errorMessage.includes('Cannot read properties of undefined (reading "forEach")') ||
        errorMessage.includes('schuco-vcl-usc-lib.mjs:10472')) {
      
      (window as any).__GLOBAL_USC_ERROR__ = {
        message: `USC Library Error: Cannot read properties of undefined (reading 'forEach'). This occurs when the article data structure is incompatible with the 3D viewer.`,
        originalError: err,
        timestamp: Date.now()
      };
    }
    
    (window as any).__APP_RUNTIME_ERROR__ = err;
  });
